declare global {
  interface Window {
    __chunkReloadPending?: boolean;
  }
}

export const RELOAD_GUARD_KEY = 'chunk_reload_at';
export const RELOAD_WINDOW_MS = 5 * 60 * 1000;
export const MAX_JITTER_MS = 5000;

// A blocked sessionStorage counts as "attempt spent": reloading without a guard could loop forever.
function claimReloadAttempt(): boolean {
  try {
    const lastAttemptAt = Number(
      window.sessionStorage.getItem(RELOAD_GUARD_KEY) || '0',
    );
    if (Date.now() - lastAttemptAt < RELOAD_WINDOW_MS) {
      return false;
    }
    window.sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
    return true;
  } catch {
    return false;
  }
}

// The random delay spreads the reloads of everyone hit by the same deploy so the API does not get a burst.
export function scheduleChunkReload(): boolean {
  if (window.__chunkReloadPending) {
    return true;
  }
  if (!claimReloadAttempt()) {
    return false;
  }
  window.__chunkReloadPending = true;
  window.setTimeout(
    () => window.location.reload(),
    Math.random() * MAX_JITTER_MS,
  );
  return true;
}
